/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
import moment from 'moment-timezone';

import { Form } from 'vform';
import {HasError, AlertError} from 'vform/src/components/bootstrap4';
window.Form = Form;

import Gate from "./Gate";
Vue.prototype.$gate = new Gate(window.user);

import Swal from 'sweetalert2';

import LoadScript from 'vue-plugin-load-script';

import MarqueeText from 'vue-marquee-text-component';

import IgnoredWords from './ignored_words.json';
Vue.prototype.$ignoredWords = IgnoredWords;

import { VueEditor, Quill } from "vue2-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-vue";
import ImageCompress from 'quill-image-compress';

Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register('modules/imageCompress', ImageCompress);

window.Vue.use(LoadScript);

import VueWordCloud from 'vuewordcloud';
import {Sketch} from 'vue-color';
import AvatarCropper from "vue-avatar-cropper";
import { ToggleButton } from 'vue-js-toggle-button';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/es';

import Roller from "vue-roller";

import VueTagsInput from '@johmun/vue-tags-input';
import VueSelect from 'vue-select';

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Mexico_City';
const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  })
window.Swal = Swal;
window.Toast = Toast;

import VueProgressBar from 'vue-progressbar'
Vue.use(VueProgressBar, {
    color: 'rgb(1, 160, 199)',
    failedColor: 'red',
    height: '3px'
  });

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)


/**
 * Routes imports and assigning
 */
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import routes from './routes';

const router = new VueRouter({
    mode: 'history',
    routes
});
// Routes End

/**
 * Translations
 */
 window.translate=require('./VueTranslation/Translation').default.translate;
 Vue.prototype.translate=require('./VueTranslation/Translation').default.translate;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 
// Components
Vue.component('pagination', require('laravel-vue-pagination'));
Vue.component('dashboard', require('./components/Dashboard.vue'));

Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue').default
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue').default
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue').default
);

Vue.component(
    'not-found',
    require('./components/NotFound.vue').default
);

Vue.component(
    'feed',
    require('./components/dashboard/Feed.vue').default
);

Vue.component(
    'social-timeline',
    require('./components/dashboard/SocialTimeline.vue').default
);

Vue.component(
    'social-searcher',
    require('./components/dashboard/SocialSearcher.vue').default
);
Vue.component(
    'loader',
    require('./components/Loader.vue').default
);
Vue.component(
    'radar',
    require('./components/Radar.vue').default
);
Vue.component(
    'news-reel',
    require('./components/dashboard/NewsReel.vue').default
);
Vue.component(
    'stock-ticker',
    require('./components/widgets/StockTicker.vue').default
);
Vue.component(
    'personal-news',
    require('./components/dashboard/PersonalNews.vue').default
);
Vue.component(
    'markers',
    require('./components/dashboard/Markers.vue').default
);
Vue.component(
    'tag-cloud',
    require('./components/dashboard/TagCloud.vue').default
);

Vue.component(
    'no-subscription',
    require('./components/NoSubscription.vue').default
);
Vue.component(
    'dark-switch',
    require('./components/DarkSwitch.vue').default
);
Vue.component(
    'chamber-search',
    require('./components/dashboard/ChamberSearch.vue').default
);
Vue.component(
    'chamber-today',
    require('./components/dashboard/ChamberToday.vue').default
);

Vue.component('marquee-text', MarqueeText);
Vue.component('vue-editor', VueEditor);
Vue.component(VueWordCloud.name, VueWordCloud);
Vue.component('color-picker', Sketch);
Vue.component('AvatarCropper', AvatarCropper);
Vue.component('ToggleButton', ToggleButton);
Vue.component('date-picker', DatePicker);
Vue.component('Roller', Roller);
Vue.component('vue-tags-input', VueTagsInput)
Vue.component('v-select', VueSelect)

moment.locale(document.documentElement.lang);
// Filter Section
Vue.filter('localDate', function(value) {
    moment.locale(document.documentElement.lang);
    let date = moment.utc(value, 'YYYY-MM-DD HH:mm:ss +00000');
    if (value) {
        return date.tz(timezone).format('dddd DD MMMM YYYY HH:mm')
    }
});

Vue.filter('localDateNoHour', function(value) {
    moment.locale(document.documentElement.lang);
    let date = moment.utc(value, 'YYYY-MM-DD HH:mm:ss +00000');
    if (value) {
        return date.tz(timezone).format('dddd DD MMMM YYYY')
    }
});

Vue.filter('formatSocialSearchPost', function(post) {
    let formattedText = post.text;
    if(post.tags){
        post.tags.forEach((tag) => {
            let completeTag = '#'+tag['text'];
            let anchor = '<a target="_BLANK" href="'+tag['url']+'">'+completeTag+'</a>';
            formattedText = formattedText.replace(completeTag, anchor);
        });
    }
    if(post.userMentions){
        post.userMentions.forEach((userMention) => {
            let completeUserMention = '@'+userMention['text'];
            let anchor = '<a target="_BLANK" href="'+userMention['url']+'">'+completeUserMention+'</a>';
            formattedText = formattedText.replace(completeUserMention, anchor);
        });
    }
    if(post.urls){
        post.urls.forEach((url) => {
            let anchor = '<a target="_BLANK" href="'+url['url']+'">'+url['text']+'</a>';
            formattedText = formattedText.replace(url['text'], anchor);
        });
    }
    return formattedText;
});

Vue.filter('stripHTML', function (value) {
    const div = document.createElement('div');
    div.innerHTML = value;
    const text = div.textContent || div.innerText || '';
    return text;
});

Vue.filter('strLimit', function (value, size) {
    if (!value) return '';
    value = value.toString();
  
    if (value.length <= size) {
      return value;
    }
    return value.substr(0, size) + '...';
});

Vue.filter('userSetting', function (value, size) {
    if (!value) return '';
    value = value.toString();
  
    if (value.length <= size) {
      return value;
    }
    return value.substr(0, size) + '...';
});

Vue.filter('yesno', value => (value ? '<i class="fas fa-check green"></i>' : '<i class="fas fa-times red"></i>'));

Vue.filter('text_color_class', function (color) {
    if(!color) return 'black';
    // Variables for red, green, blue values
    var r, g, b, hsp;
            
    // Check the format of the color, HEX or RGB?
    if (color.match(/^rgb/)) {

        // If RGB --> store the red, green, blue values in separate variables
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
        
        r = color[1];
        g = color[2];
        b = color[3];
    } 
    else {
        
        // If hex --> Convert it to RGB: http://gist.github.com/983661
        color = +("0x" + color.slice(1).replace( 
        color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }
    
    // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
    hsp = Math.sqrt(
        0.299 * (r * r) +
        0.587 * (g * g) +
        0.114 * (b * b)
    );

    // Using the HSP value, determine whether the color is light or dark
    return hsp>127.5 ? 'black' : 'white';
});

Vue.filter('network_color', function (network, alpha) {
    let darkMode = $('body').hasClass('dark-mode');
    switch(network){
        case 'web':
            return darkMode ? 'rgba(96, 28, 207, '+alpha+')' : 'rgba(96, 28, 207, '+alpha+')';
        case 'facebook':
            return darkMode ? 'rgba(24, 119, 242, '+alpha+')' : 'rgba(24, 119, 242, '+alpha+')';
        case 'x':
            return darkMode ? 'rgba(29, 161, 242, '+alpha+')' : 'rgba(29, 161, 242, '+alpha+')';
        case 'instagram':
            return darkMode ? 'rgba(221, 42, 123, '+alpha+')' : 'rgba(195, 42, 163, '+alpha+')';
        case 'youtube':
            return darkMode ? 'rgba(222, 0, 0, '+alpha+')' : 'rgba(255, 0, 0, '+alpha+')';
        case 'tumblr':
            return darkMode ? 'rgba(158, 161, 195, '+alpha+')' : 'rgba(53, 70, 93, '+alpha+')';
        case 'reddit':
            return darkMode ? 'rgba(255, 87, 0, '+alpha+')' : 'rgba(255, 69, 0, '+alpha+')';
        default :
            return darkMode ? 'rgba(255, 255, 244, '+alpha+')' : 'rgba(0, 0, 0, '+alpha+')';
    }
});
Vue.filter('sentiment_color', function (sentiment, alpha) {
    let darkMode = $('body').hasClass('dark-mode');
    switch(sentiment){
        case 'positive':
            return darkMode ? 'rgba(0, 188, 140, '+alpha+')' : 'rgba(40, 167, 69, '+alpha+')';
        case 'negative':
            return darkMode ? 'rgba(231, 76, 60, '+alpha+')' : 'rgba(220, 53, 69, '+alpha+')';
        default :
            return darkMode ? 'rgba(255, 255, 244, '+alpha+')' : 'rgba(0, 0, 0, '+alpha+')';
    }
});

Vue.filter('capitalize', function (text) {
    return text.charAt(0).toUpperCase() + text.slice(1)
});

Vue.filter('heatmap_class', function (ratio) {
    if(ratio < 0.325){
        return 'danger';
    }else if(ratio >= 0.325 && ratio < 0.655){
        return 'warning';
    }else if(ratio >= 0.655){
        return 'success';
    }
});

const icon_classes = {
    web: 'fa fa-globe',
    facebook: 'fab fa-facebook',
    x: 'fab fa-x-twitter',
    youtube: 'fab fa-youtube',
    instagram: 'fab fa-instagram',
    reddit: 'fab fa-reddit',
    dailymotion: 'fab fa-dailymotion',
    tumblr: 'fab fa-tumblr',
    vimeo: 'fab fa-vimeo',
    vkontakte: 'fab fa-vk',
    flickr: 'fab fa-flickr',
    video: 'fas fa-video',
    status: 'fas fa-user',
    photo: 'fas fa-camera',
    link: 'fas fa-link',
    retweets: 'fas fa-retweet',
    likes: 'fas fa-heart',
    comments: 'fas fa-comments',
    ups: 'fas fa-arrow-up',
    views: 'fas fa-eye',
    reposts: 'fas fa-bullhorn',
    notes: 'fas fa-comments'
};

const color_classes= {
    positive: 'success',
    neutral: 'secondary',
    negative: 'danger'
}

Vue.filter('icon_class', function (icon) {
    return icon_classes[icon];
});

Vue.filter('color_class', function (color) {
    return color_classes[color];
});

// end Filter

// Add a response interceptor
var swapSessionMessage = false;
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    $('[data-toggle="tooltip"]').tooltip('hide');
    $('[data-toggle="popover"]').popover('hide');
    return response;
    }, function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if(error.response.status === 401 && error.response.statusText == 'Unauthorized') {
        document.getElementById('logout-form').submit();
    }
    if(!swapSessionMessage && error.response.status === 403 && error.response.data=="swap_session") {
        swapSessionMessage = true;
        Swal.fire({
            title: window.translate('messages.swap_session_title'),
            text: window.translate('messages.swap_session_message'),
            confirmButtonText: window.translate('messages.continue_here'),
            showCancelButton: true,
            cancelButtonColor: '#d33',
            confirmButtonColor: '#3085d6',
            cancelButtonText: window.translate('messages.exit'),
            })
            .then((result) => {
                if (result.value) {
                    axios.get("/api/user/swapSession/?swap_session=1").then(({ data }) => {
                        window.location.href = "/monitor";
                    })
                    .catch((error)=>{
                        document.getElementById('logout-form').submit();
                    });
                }else{
                    document.getElementById('logout-form').submit();
                }
            });
    }
    return Promise.reject(error);
  });
  Vue.directive('tooltip', function(el, binding){
    $(el).tooltip({
        title: binding.value,
        placement: binding.arg,
        trigger: 'hover'             
    });
  });
  Vue.directive('popover', function(el, binding){
    $(el).popover({
        title: binding.value.title,
        content: binding.value.content,
        placement: binding.arg,
        trigger: 'hover'         
    });
  });

const app = new Vue({
    el: '#app',
    router,
    data: {
        app_config: {
            dark_mode: false,
            timezone: 'America/Mexico_City'
        }
    },
    mounted () {
        //  [App.vue specific] When App.vue is finish loading finish the progress bar
        this.$Progress.finish()
        this.app_config.dark_mode = $('body').hasClass('dark-mode');
        this.app_config.timezone = timezone;
    },
    created () {
        //  [App.vue specific] When App.vue is first loaded start the progress bar
        this.$Progress.start()
        //  hook the progress bar to start before we move router-view
        this.$router.beforeEach((to, from, next) => {
            //  does the page we want to go to have a meta.progress object
            $('[data-toggle="tooltip"]').tooltip('hide');
            $('[data-toggle="popover"]').popover('hide');
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress
                // parse meta tags
                this.$Progress.parseMeta(meta)
            }
            //  start the progress bar
            this.$Progress.start()
            //  continue to next page
            next()
        })
        //  hook the progress bar to finish after we've finished moving router-view
        this.$router.afterEach((to, from) => {
            //  finish the progress bar
            this.$Progress.finish()
        });
    },
    watch:{
        $route (to, from){
            if($('body').hasClass('sidebar-open')){
                $('.main-header .navbar-nav a[data-widget="pushmenu"]').trigger('click');
            }
        }
    } 
});
